export function neverError(x: never): never {
  throw new Error('Unexpected value: ', x);
}
